import { render, staticRenderFns } from "./form-cash-register.vue?vue&type=template&id=1d933f5a&scoped=true&lang=pug&"
import script from "./form-cash-register.vue?vue&type=script&lang=js&"
export * from "./form-cash-register.vue?vue&type=script&lang=js&"
import style0 from "./form-cash-register.vue?vue&type=style&index=0&id=1d933f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d933f5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
